import { boxSlotSessionKeys } from "@/modules/boxSlotSession/gateway/boxSlotSessionKey"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import { BoxSessionDetailsEntity } from "@/modules/boxSlotSession/entities/boxSessionEntity"

export function useBoxSlotGetSession(sessionId: string) {
  const { boxSlotSessionApi } = useServicesContext()

  return useSuspenseQuery({
    queryKey: boxSlotSessionKeys.session(sessionId),
    queryFn: async () => {
      const result = await boxSlotSessionApi.getSessionDetails(sessionId)
      return BoxSessionDetailsEntity.fromDto(result)
    },
  })
}

export function useBoxSlotFetchSession(sessionId: string | null) {
  const { boxSlotSessionApi } = useServicesContext()

  return useQuery({
    queryKey: boxSlotSessionKeys.session(sessionId!),
    queryFn: async () => {
      const result = await boxSlotSessionApi.getSessionDetails(sessionId!)
      return BoxSessionDetailsEntity.fromDto(result)
    },
    enabled: !!sessionId,
  })
}
